export const locale = {
  lang: "vi",
  data: {
  }
};
